import React from "react";
import { Box, Text, Image } from "@chakra-ui/react";

import ico from "../../../../../../../../../assets/builder/stickers_1.svg";

function CategoryBtn({ label, val, handleFilter }) {
	return (
		<Box
			display="flex"
			flexDir="column"
			justifyContent="center"
			alignItems="center"
			cursor="pointer"
			onClick={() => {
				handleFilter(val);
			}}
		>
			<Box w="100%" pt="3px" pb="3px">
				<Image src={ico} w="30px" m="auto" />
			</Box>
			<Text fontSize={"14px"}>{label}</Text>
		</Box>
	);
}

export default CategoryBtn;
